import React, { useState } from 'react';
import API_CONFIG from '../config/api.config';

const MockModeBanner = () => {
  const [collapsed, setCollapsed] = useState(false);

  if (!API_CONFIG.MOCK) return null;

  return (
    <div style={{
      position: 'fixed', bottom: 16, left: 16, zIndex: 9999,
      background: '#1a1a2e', color: '#fff', borderRadius: 10,
      boxShadow: '0 4px 20px rgba(0,0,0,0.4)',
      fontFamily: 'monospace', fontSize: 12,
      border: '1px solid #f59e0b',
      overflow: 'hidden', minWidth: collapsed ? 'auto' : 280,
      transition: 'all 0.3s',
    }}>
      {/* Header */}
      <div
        onClick={() => setCollapsed(!collapsed)}
        style={{
          display: 'flex', alignItems: 'center', gap: 8,
          padding: '8px 12px', cursor: 'pointer',
          background: '#f59e0b', color: '#000',
        }}
      >
        <span style={{ fontSize: 16 }}>🧪</span>
        <strong>MOCK MODE</strong>
        <span style={{ marginLeft: 'auto', fontSize: 10 }}>{collapsed ? '▲' : '▼'}</span>
      </div>

      {/* Body */}
      {!collapsed && (
        <div style={{ padding: '10px 12px' }}>
          <div style={{ marginBottom: 8, color: '#f59e0b' }}>
            Using local mock data — no API calls
          </div>
          <div style={{ color: '#9ca3af', marginBottom: 8, lineHeight: 1.6 }}>
            <div>API: <span style={{ color: '#6ee7b7' }}>{API_CONFIG.BASE_URL}</span></div>
            <div>Delay: <span style={{ color: '#6ee7b7' }}>{API_CONFIG.MOCK_DELAY}ms</span></div>
          </div>

          {/* Test credentials */}
          <div style={{ borderTop: '1px solid #374151', paddingTop: 8, marginTop: 4 }}>
            <div style={{ color: '#f59e0b', marginBottom: 4 }}>Test Credentials:</div>
            {[
              { role: 'Mentor',  email: 'mentor@devbrains.in' },
              { role: 'Mentee',  email: 'mentee@devbrains.in' },
              { role: 'Admin',   email: 'admin@devbrains.in'  },
            ].map(({ role, email }) => (
              <div key={role} style={{ marginBottom: 2, color: '#d1d5db' }}>
                <span style={{ color: '#6ee7b7', width: 50, display: 'inline-block' }}>{role}:</span>
                <span
                  style={{ cursor: 'pointer', textDecoration: 'underline' }}
                  title="Click to copy"
                  onClick={() => navigator.clipboard?.writeText(email)}
                >
                  {email}
                </span>
              </div>
            ))}
            <div style={{ color: '#6b7280', marginTop: 4 }}>Password: password123</div>
          </div>

          {/* Switch to API */}
          <div style={{ borderTop: '1px solid #374151', paddingTop: 8, marginTop: 8, color: '#6b7280', lineHeight: 1.6 }}>
            To use real API, set in <code style={{ color: '#f59e0b' }}>.env</code>:
            <pre style={{ margin: '4px 0 0', color: '#6ee7b7', fontSize: 11 }}>
              REACT_APP_MOCK=false{'\n'}
              REACT_APP_API_URL=http://localhost:8000/v1
            </pre>
          </div>
        </div>
      )}
    </div>
  );
};

export default MockModeBanner;
